/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Status_PendingInputs */

const en_us2_board_status_pending = /** @type {(inputs: Board_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under review`)
};

const pt_br2_board_status_pending = /** @type {(inputs: Board_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em análise`)
};

const pt_pt2_board_status_pending = /** @type {(inputs: Board_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em análise`)
};

/** @type {(inputs: Board_Status_PendingInputs) => LocalizedString} */
const es_419_board_status_pending = en_us2_board_status_pending;

/** @type {(inputs: Board_Status_PendingInputs) => LocalizedString} */
const fr_fr2_board_status_pending = en_us2_board_status_pending;

/** @type {(inputs: Board_Status_PendingInputs) => LocalizedString} */
const de_de2_board_status_pending = en_us2_board_status_pending;

/** @type {(inputs: Board_Status_PendingInputs) => LocalizedString} */
const it_it2_board_status_pending = en_us2_board_status_pending;

/**
* | output |
* | --- |
* | "Under review" |
*
* @param {Board_Status_PendingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_status_pending = /** @type {((inputs?: Board_Status_PendingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Status_PendingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_status_pending(inputs)
	if (locale === "es-419") return es_419_board_status_pending(inputs)
	if (locale === "pt-PT") return pt_pt2_board_status_pending(inputs)
	if (locale === "fr-FR") return fr_fr2_board_status_pending(inputs)
	if (locale === "de-DE") return de_de2_board_status_pending(inputs)
	if (locale === "it-IT") return it_it2_board_status_pending(inputs)
	return en_us2_board_status_pending(inputs)
});
export { board_status_pending as "board.status_pending" }